/**
 * Session app-data for Hair Analyze (workspace Page Setup).
 * Uses the same enterprise salon session API as the skin flow so org page-setup applies.
 *   /enterprise/salon/session/app-data/<token>/page-setup
 * Dev: setupProxy.js → localhost:5013 /session/...
 */
import { hairAppPath as HairAppPath, HAIR_APP_BASE as Hair_APP_BASE } from './hairApp';

export const SESSION_APP_DATA_BASE = '/enterprise/salon/session/app-data';
export const SESSION_MASTER_TOKEN_URL = '/enterprise/salon/session/app-data/-/public-token';

/** Used when the URL has no `/session/:token` segment and sessionStorage has no token yet. Only injected on `skinanalyze.nyufaz.com`. */
export const SESSION_APP_FALLBACK_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo5LCJleHAiOjE3NzA4ODEwMDl9.GJoVxK5KZ-zmkTiIMvRVWEmq9PbxbMDqv1HRriW6i3g';

/** Production skin app host — fallback token and “home without /session/:token” apply only here. */
export const SESSION_APP_FALLBACK_HOSTNAME = 'skinanalyze.nyufaz.com';

/** Local dev (CRA/Vite default) — same fallback behavior as production. Use `location.host` (includes port). */
export const SESSION_APP_FALLBACK_DEV_HOST = 'localhost:3000';

export function isSessionAppFallbackHost() {
  if (typeof window === 'undefined' || !window.location?.host) return false;
  const host = window.location.host;
  return host === SESSION_APP_FALLBACK_HOSTNAME || host === SESSION_APP_FALLBACK_DEV_HOST;
}

/** Home under /Hair: `/Hair` (landing) or `/hair/session/:token` when a token is present. */
export function getSessionLandingPath(token) {
  const t = typeof token === 'string' ? token.trim() : '';
  if (!t) return HairAppPath('/');
  if (t === SESSION_APP_FALLBACK_TOKEN && isSessionAppFallbackHost()) return HairAppPath('/');
  return `${Hair_APP_BASE}/session/${t}`;
}
